import api from '../api'

const state = {
  all: [],
  font: null
}

const actions = {
  getFonts: ({ state, commit }) => {
    return api.getAllFonts().then(fonts => {
      return commit('setAllFonts', fonts)
    })
  },
  addFont: ({ state, commit }, data) => {
    return api.addSingleFont(data).then((response) => {
      return commit('setSingleFont', response.data)
    })
  }
}

const mutations = {
  setAllFonts (state, fonts) {
    state.all = fonts
  },
  setSingleFont (state, font) {
    state.font = font
  }
}

const getters = {
  all: state => {
    return state.all
  },
  font: state => {
    return state.font
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/fonts.js